import { all, call, put, takeEvery } from "redux-saga/effects";

import { patch } from "redux/fetch";

import { uiSetSubmitting } from "redux/ws/actions";
import util from "js/util";
import { authUpdatePortalUser } from "./actions";

/**
 * Used on the portal account page to update the user's account.
 */
function* updatePortalUser({ payload: { user, emailSettings, handleError, csrfToken } }) {
    yield put(uiSetSubmitting(true));

    try {
        yield call(patch, "/api/v1/auth/", { ...user, csrf_token: csrfToken });
        yield call(patch, "/api/v1/email/settings/", { ...emailSettings, csrf_token: csrfToken });
        util.showToast();
    } catch (e) {
        const error = e.message;
        if (error.toLowerCase().indexOf("email") > -1) {
            handleError("email", error);
        }
    } finally {
        yield put(uiSetSubmitting(false));
    }
}

export default function* authSagas() {
    yield all([takeEvery(authUpdatePortalUser, updatePortalUser)]);
}
